/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width: 800px) {\r\n    .desktop-hidden[_ngcontent-%COMP%] {\r\n        display: initial;\r\n    }\r\n    .mobile-hidden[_ngcontent-%COMP%] {\r\n        display: none;\r\n    }\r\n}\r\n@media screen and (min-width: 800px) {\r\n    .desktop-hidden[_ngcontent-%COMP%] {\r\n        display: none;\r\n    }\r\n    .mobile-hidden[_ngcontent-%COMP%] {\r\n        display: initial;\r\n    }\r\n}"];
export { styles as styles };
